import axios from "axios";

export default function ReceiptgroupListService(query) {
    if(query && query.toString().includes(',"multiSortMeta":[]')) {
    query = query.replace(',"multiSortMeta":[]', '')
  }

  return axios({
    method: 'get',
    // url: process.env.REACT_APP_API_HOST + "/receipt_group?" + query,  // régi végpont
    url: process.env.REACT_APP_API_HOST + "/api/v2/receipt-group?" + query,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
